import { FC } from 'react';

const Home: FC = () => (
  <div className="container center">
    <h1 className="title" data-testid="home-title">
      TECO Home
    </h1>
  </div>
);

export default Home;
